import { Typography } from 'antd';

import ChangePassword from 'components/UserProfile/ChangePassword';

import './index.scss';

const { Title } = Typography;

const ChangePasswordPage = () => {

  return (
    <div className="user-profile-page">
      <div className="header-title">
        <Title level={4} className="ml-3">Change User Password</Title>
      </div>
      <div>
        <ChangePassword
          uid={sessionStorage.user_id}
        />
      </div>
    </div>
  )
};

export default ChangePasswordPage;